import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getDirectorTypes = () => getJson('/api/director-types');
export const createDirectorType = (form) => withDone(withValidate(postJson('/api/director-types', form)))();
export const updateDirectorType = (name, form) => withDone(withValidate(putJson(`/api/director-types/${encodeURIComponent(name)}`, form)))();
export const deleteDirectorType = (name) => withDone(deleteJson(`/api/director-types/${encodeURIComponent(name)}`))();
